import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AUTHENTICATION_FEATURE_KEY, AuthenticationState } from './authentication.reducer';

// Lookup the 'Authentication' feature state managed by NgRx
export const getAuthenticationState = createFeatureSelector<AuthenticationState>(AUTHENTICATION_FEATURE_KEY);

export const getAuthenticationStatus = createSelector(
  getAuthenticationState,
  (state: AuthenticationState) => state.authenticated
);
export const getAuthenticationTokenSub = createSelector(
  getAuthenticationState,
  (state: AuthenticationState) => state.sub
);
export const getEmployeeStatus = createSelector(getAuthenticationState, (state: AuthenticationState) => state.employee);
export const getAnalyticsExcludeStatus = createSelector(
  getAuthenticationState,
  (state: AuthenticationState) => state.exclude_analytics
);
export const getUserInformation = createSelector(
  getAuthenticationState,
  (state: AuthenticationState) => state.userInfo
);
